'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function MoveRight(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { xmlns: 'http://www.w3.org/2000/svg', focusable: 'false', 'aria-hidden': true, className: 'icon-svg-arrow-move ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, fillRule: 'evenodd', d: 'M13.5000137,8.08594476 C13.5000137,8.35157007 13.3984511,8.60938288 13.2109509,8.7968831 L8.1250073,13.8828267 C7.93750708,14.0625144 7.67969427,14.1718895 7.41406895,14.1718895 C7.14844364,14.1718895 6.89844334,14.0625144 6.71094312,13.8828267 L6.12500492,13.2968885 C5.93750469,13.1093882 5.82812956,12.8515754 5.82812956,12.5859501 C5.82812956,12.3203248 5.93750469,12.062512 6.12500492,11.8750118 L8.41407015,9.58594654 L2.91406359,9.58594654 C2.35156292,9.58594654 2,9.11719598 2,8.58594535 L2,7.58594416 C2,7.05469353 2.35156292,6.58594297 2.91406359,6.58594297 L8.41407015,6.58594297 L6.12500492,4.28906523 C5.93750469,4.10937751 5.82812956,3.85156471 5.82812956,3.58593939 C5.82812956,3.32031407 5.93750469,3.06250127 6.12500492,2.88281355 L6.71094312,2.29687535 C6.89844334,2.10937513 7.14844364,2 7.41406895,2 C7.67969427,2 7.93750708,2.10937513 8.1250073,2.29687535 L13.2109509,7.38281892 C13.3984511,7.56250663 13.5000137,7.82031944 13.5000137,8.08594476 Z' })
  );
}

MoveRight.propTypes = _bcPropTypes.iconShape;

exports.default = MoveRight;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Arrows/move/Right.js
// module id = 151
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16